export default "__VITE_ASSET__DgbfoG_q__"